{
  "pt": {
    "company": {
      "actions": {
        "changeCompany": "Mudar de empresa",
        "searchCompany": "Pesquisar empresa"
      },
      "attributes": {
        "address": "Endereço",
        "email_address": "Correio eletrónico",
        "iban": "IBAN",
        "language": "Língua",
        "name": "Nome da empresa",
        "phone": "Telefone",
        "subdomain": "Subdomínio",
        "vat": "IVA"
      },
      "labels": {
        "company": "Empresa",
        "contact": "Contacto",
        "contacts": "Contactos",
        "language": "Esta é a língua predefinida da empresa para a sua página de início de sessão, clientes e membros da equipa.",
        "or": "OU"
      },
      "validation": {
        "contactAlreadyExist": "O contacto já existe. Seleccione a partir do menu pendente.",
        "mustBeEmailAddress": "É necessário um endereço de correio eletrónico válido",
        "needName": "O nome é obrigatório"
      }
    }
  }
}